import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";

export class ServicePackageItem {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  vat!: string;
  @Expose()
  @IsNumber()
  amount!: number;
  @Expose()
  @IsEnum(TRADE_TERM_APPLY_TO)
  hiddenAppliesTo!: TRADE_TERM_APPLY_TO;
  @Expose()
  @IsBoolean()
  isHidden!: boolean;
  @Expose()
  @IsBoolean()
  isPercentage!: boolean;
  @Expose()
  @IsBoolean()
  isSeparateItem!: boolean;
  @Expose()
  @IsBoolean()
  isTradeTerm!: boolean;
  @Expose()
  @IsNumber()
  ordinal!: number;
  @Expose()
  @IsOptional()
  @IsString()
  parentServicePackageItemId!: string | null;
  @Expose()
  @IsEnum(TRADE_TERM_APPLY_TO)
  percentageCalculateFrom!: TRADE_TERM_APPLY_TO;
  @Expose()
  @IsString()
  servicePackageId!: string;
  @Expose()
  @IsNumber()
  serviceTypeId!: number;
  @Expose()
  @IsBoolean()
  disableMoveUpBtn!: boolean;
  @Expose()
  @IsBoolean()
  disableMoveDownBtn!: boolean;
  @Expose()
  @IsArray()
  @Type(() => ServicePackageItem)
  @ValidateNested()
  childServicePackageItems!: Array<ServicePackageItem>;
}
